import React from "react";
import Storys from "../../components/common/mobile/Storys";
import ProductCardMobile from "../../components/common/mobile/ProductCardMobile";
import ProductsMobile from "../../components/common/mobile/ProductsMobile";
import SpecialProductsMobile from "../../components/common/mobile/SpecialProductsMobile";
import { Helmet } from "react-helmet";

const HomePageMobile = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"مرکز خرید و فروش ماشین های سنگین"}</title>
        <meta name="description" content={"مرکز خرید و فروش ماشین های سنگین"} />
        <meta name="keywords" content={""} />
        <meta name="og:description" content={"مرکز خرید و فروش ماشین های سنگین"} />
        <meta name="og:title" content={"مرکز خرید و فروش ماشین های سنگین"} />
      </Helmet>{" "}
      <Storys />
      <SpecialProductsMobile />
      <ProductsMobile />
    </>
  );
};

export default HomePageMobile;
